module.exports = ".float-button {\n  position: fixed;\n  bottom: 0px;\n  z-index: 10;\n  right: 0px; }\n\n.white-div {\n  background: #fff;\n  padding: 5px;\n  border: 1px solid #e5ebec;\n  border-radius: 5px; }\n\n.voltar {\n  margin-left: 58px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/views/approvals/edit-multi-approvals/edit-multi-approvals.component.scss
// module id = ./src/app/views/approvals/edit-multi-approvals/edit-multi-approvals.component.scss
// module chunks = main